import ChartCommandResults from './ChartCommandResults'
import AlertAppliedCard from './AlertAppliedCard'
import type { ChartCommandApplyResults } from '../../screener/aiChat/types'

function alertArtifactEntries(results: ChartCommandApplyResults) {
    return results.applied.filter(
        (entry) => (entry.op === 'create_alert' || entry.op === 'update_alert') && entry.alert,
    )
}

/**
 * Success ticks duplicate what the assistant already said in prose — show them
 * only when the reply is empty (commands-only turn) or when something failed.
 * Alert creates always show the applied-alert artifact with exact condition text.
 */
export function chartCommandResultsFooter(
    content: string | undefined,
    results: ChartCommandApplyResults | undefined,
) {
    if (!results || (!results.applied.length && !results.failed.length)) {
        return undefined
    }

    const alertArtifacts = alertArtifactEntries(results)
    const nonAlertApplied = results.applied.filter((entry) => !alertArtifacts.includes(entry))
    const explained = Boolean(content?.trim())

    if (alertArtifacts.length) {
        return (
            <>
                {alertArtifacts.map((entry) => (
                    <AlertAppliedCard key={entry.alert!.id} alert={entry.alert!} />
                ))}
                {(results.failed.length > 0 || nonAlertApplied.length > 0) && (
                    <ChartCommandResults
                        results={{
                            applied: nonAlertApplied,
                            failed: results.failed,
                        }}
                    />
                )}
            </>
        )
    }

    if (explained && (!results.failed.length || !results.applied.length)) {
        return undefined
    }
    if (explained) {
        return <ChartCommandResults results={{ applied: [], failed: results.failed }} />
    }
    return <ChartCommandResults results={results} />
}
